'use strict';

class SignupController {
  constructor($log,
              $q,
              $rootScope,
              $scope,
              $filter,
              $interval,
              $timeout,
              $translate,
              utils,
              $state,
              config,
              CloudConfigService,
              AuthService,
              UsersService,
              LocationsService,
              OrganizationService,
              SubscriptionsService,
              I18nService,
              PermissionsService,
              ToastsService) {

    // #region Define fields

    const $t = $filter('translate');
    let secondsUntilNextPasscodeSend = 120;
    const PWD_REGEX_KEY = 'Password-Regex';
    const LOCAL_STORAGE_API_KEY = 'Auth-Key';
    let codeCountdownInterval;
    let flowFile;

    // Form identifiers
    const FORM_PASSWORD_FIELD_ID = '#password';
    const FORM_PASSCODE_FIELD_ID = '#passcode';

    // Organization properties
    const ORG_BUSINESS_PROPERTY = 'businessUrl';
    const ORG_COMPANY_PROPERTY = 'businessName';
    const ORG_WEBSITE_PROPERTY = 'websiteDirectUrl';
    const ORG_WEBSITE_URI = 'https://peoplepowerfamily.com';
    const ORG_LOGO_PROPERTY = 'logo';

    $scope.hideHint = false;
    $scope.availableLanguages = [];
    $scope.externalMsg = $rootScope.errorMsg;
    $rootScope.errorMsg = void 0;
    $scope.loading = true;

    $scope.uiStep = 'user';
    $scope.user = {
      phoneCode: 1,
      email: ($state.params && $state.params.email) ? $state.params.email : ''
    };
    $scope.company = {
      name: ''
    };

    // TODO: Hide cloud dropdown depends on server config
    // const maestroLocal = window.location.hostname.indexOf('localhost') === 0;
    // const showCloudDropdown = config.getConfigByKey('environment').showCloudDropdown;
    // $scope.showClouds = maestroLocal && showCloudDropdown;

    // #endregion

    // #region Put on scope only the stuff we really need there
    angular.extend($scope, {
      onLanguageDropdownSelectionChange: onLanguageDropdownSelectionChange,
      keyPressSignup: keyPressSignup,
      logoAddHandler: logoAddHandler,
      signup: signup,
      resendCode: resendCode,
      cancelCodeCountdown: cancelCodeCountdown,
      twoFactorAuth: false,
      isSaveAttempt: false,
      userFormFilled: false,
      isPasswordWeak: false,
      isUsernameUsed: false,
      message: '',
      countdown: 0,
      confirm: confirm
    });
    // #endregion

    // Operation token for account registration
    let operationToken = AuthService.operationToken();
    $scope.$on('$destroy', () => {
      operationToken.stop();
    });

    $q.when(AuthService.isAuthenticated())
      .then((result) => {
        if (result) {
          getUserInfo();
        }
        initPage();
      });

    // #region Signup Methods
    function getConnectSettings() {
      return CloudConfigService.getClouds()
        .then(clouds => {
          $scope.clouds = clouds;
          // TODO: Display cloud selector for non-Production host
          // $scope.showClouds = $scope.showClouds ? true : $scope.clouds.some(cloud => cloud.servers.some(server => window.location.hostname.indexOf(server.host) === 0));
        })
        .then(() => CloudConfigService.getCurrentCloud())
        .then(currentCloud => {
          // Find out index of the current cloud and select it in the clouds dropdown
          $scope.selectedCloudIndex = $scope.clouds.findIndex(c => c.name === currentCloud.name);
          $scope.selectedCloud = $scope.clouds[$scope.selectedCloudIndex];
          // Update the dropdown state
          $('#drop-clouds').dropdown('set selected', $scope.selectedCloudIndex.toString());
        })
        .catch(err => handleError(err));
    }

    /**
     * Save user info into LocalStorage and check permissions.
     */
    function getUserInfo() {
      return UsersService.getCurrentUserInfo(true)
        .then((data) => {
          $scope.userInfo = data;
          $scope.twoFactorAuth = false;

          // Now safely navigate to the dashboard
          if (PermissionsService.canIUseMaestro()) {
            $state.go('main');
            return;
          }

          if (data && data.keyType === 11) {
            initCompanyStep();
          } else {
            // Login to get admin API_KEY
            const apiKey = utils.getStorageItem(LOCAL_STORAGE_API_KEY);
            return AuthService.loginByApiKey(apiKey)
              .then((data) => {
                if (data && data.resultCode === 17) {
                  $scope.twoFactorAuth = true;
                  $scope.message = data.resultCodeMessage || data.resultCodeDesc;
                  $scope.loading = false;
                } else {
                  return getUserInfo();
                }
              })
              .catch((err) => handleError(err));
          }
        })
        .catch((err) => handleError(err));
    }

    /**
     * API error handler
     * @param {Object} error
     * @param {boolean} isSignup Flag to determine if error comes after registration attempt
     */
    function handleError(error, isSignup) {
      $scope.loading = false;

      if (isSignup) {
        // Weak password during registration attempt
        if (error.resultCode === 46) {
          $scope.isPasswordWeak = true;
          return ToastsService.warning($t('signup.errors.password.title'), $t('signup.errors.password.desc'));
          // Email or phone already used by another account
        } else if (error.resultCode === 20) {
          $scope.isUsernameUsed = true;
        }
      }
      utils.handleApiError(error);
    }

    function initPwdRegex() {
      let regex = utils.getStorageItem(PWD_REGEX_KEY);
      if (regex) {
        updateUserFormRules(regex);
        return;
      }

      return AuthService.getPasswordRegex()
        .then((data) => {
          utils.setStorageItem(PWD_REGEX_KEY, data);
          updateUserFormRules(data);
        });
    }

    function updateUserFormRules(regex) {
      // Combine Server regex and empty rule
      let newRegex = '^(?:' + regex.slice(1, -1) + '|)$';
      let fullRegex = new RegExp(newRegex);
      fullRegex = 'regExp[' + fullRegex + ']';

      $('#signup-form').form('add rule', 'password', {
        rules: [
          {
            type: 'empty',
            prompt: $t('prompt.password.empty')
          },
          {
            type: fullRegex,
            prompt: $t('users.new.form.passwordRegex')
          }
        ]
      });
    }

    function initPage() {
      initLanguage();

      $('#drop-clouds').dropdown({
        onChange: function(value, text) {
          $scope.$applyAsync(() => {
            $scope.selectedCloudIndex = value;
            $scope.selectedCloud = $scope.clouds[$scope.selectedCloudIndex];
            CloudConfigService.setCurrentCloud(angular.fromJson(angular.toJson($scope.selectedCloud)));
          });
        }
      });

      $('#signup-form').form({
        inline: true,
        fields: {
          firstName: {
            rules: [
              {
                type: 'empty',
                prompt: $t('prompt.firstname')
              }
            ]
          },
          lastName: {
            rules: [
              {
                type: 'empty',
                prompt: $t('prompt.lastname')
              }
            ]
          },
          email: {
            rules: [
              {
                type: 'empty',
                prompt: $t('prompt.email.your')
              },
              {
                type: `regExp[${utils.emailRegexp()}]`,
                prompt: $t('prompt.email.valid')
              }
            ]
          },
          phoneCode: {
            rules: [
              {
                type: 'integer[1..999]',
                prompt: $t('prompt.signup.phone.code')
              }
            ]
          },
          phone: {
            rules: [
              {
                type: 'empty',
                prompt: $t('users.new.errors.noPhone')
              },
              {
                type: 'regExp[/^[0-9]{7,14}$/gi]', // 7-14 digits
                prompt: $t('prompt.signup.phone.length')
              }
            ]
          },
          password: {
            rules: [
              {
                type: 'empty',
                prompt: $t('prompt.password.empty')
              }
            ]
          },
          passwordRepeat: {
            depends: 'password',
            rules: [
              {
                type: 'match[password]',
                prompt: $t('prompt.passwordRepeat.match')
              }
            ]
          }
        }
      });

      $('#passcode-form').form({
        inline: true,
        fields: {
          passcode: {
            identifier: 'passcode',
            rules: [
              {
                type: 'empty',
                prompt: $t('prompt.passcode.enter')
              },
              {
                type: 'regExp[/^[A-Za-z0-9]{6}$/gi]',
                prompt: $t('prompt.passcode.invalid')
              }
            ]
          }
        }
      });

      getConnectSettings();
      getPasscodeTimeout();
      initPwdRegex();

      $scope.loading = false;
      $scope.$watch('user.phoneCode', (newValue, oldValue) => {
        if (!$scope.isSaveAttempt || $scope.uiStep !== 'user' || $scope.twoFactorAuth) {
          return;
        }
        if (newValue !== oldValue) {
          triggerFormValidation();
        }
      });

      // Watch for user form changes
      $scope.$watchGroup([
        'user.firstName',
        'user.lastName',
        'user.email',
        'user.phoneCode',
        'user.phoneNumber',
        'user.password',
        'user.passwordRepeat'
      ], (newValue, oldValue) => {
        if ($scope.uiStep !== 'user' || $scope.twoFactorAuth) {
          return;
        }

        if ($scope.isSaveAttempt) {
          // Watch for password change
          if (oldValue[5] !== newValue[5]) {
            $scope.isPasswordWeak = false;
          }
          // Watch for email and phone change
          if (oldValue[2] !== newValue[2] || oldValue[4] !== newValue[4]) {
            $scope.isUsernameUsed = false;
          }
        }
        $scope.userFormFilled = !newValue.some(el => !el);
      });
    }

    function getPasscodeTimeout() {
      return AuthService.getPasscodeResendTimeout()
        .then((timeout) => {
          secondsUntilNextPasscodeSend = timeout;
        }, (err) => utils.handleApiError(err));
    }

    function initLanguage() {
      $scope.availableLanguages = I18nService.getLocalesList();
      $scope.selectedLng = I18nService.getLocale();
      $scope.selectedLngIndex = $scope.availableLanguages.findIndex(l => l.code === $scope.selectedLng.code);

      $('#drop-lang').dropdown({
        onChange: function(value, text) {
          $scope.$applyAsync(() => {
            $scope.selectedLngIndex = value;
            let lng = $scope.availableLanguages[value];
            onLanguageDropdownSelectionChange(lng);
          });
        }
      });
    }

    function onLanguageDropdownSelectionChange(lng) {
      I18nService.setLocale(lng);
      $scope.selectedLng = I18nService.getLocale();
    }

    function keyPressSignup($event) {
      if ($event.keyCode === 13) {
        $scope.hideHint = true;
        $scope.signup();
      }
    }

    function triggerFormValidation() {
      let formElement = $('#signup-form');
      const phoneProps = {
        code: $scope.user.phoneCode.toString(),
        type: $scope.selectedPhoneType && $scope.selectedPhoneType.id
      };
      formElement.form('remove fields', ['phone']);
      formElement.form('add rule', 'phone', {
        rules: [
          {
            type: 'empty',
            prompt: $t('users.new.errors.noPhone')
          },
          {
            type: 'regExp[/^[0-9]{7,14}$/gi]', // 7-14 digits
            prompt: $t('prompt.signup.phone.length')
          },
          {
            type: `phoneValidation[${JSON.stringify(phoneProps)}]`, // custom validation
            prompt: $t('prompt.signup.phone.invalid')
          }
        ]
      });
      formElement.form('validate form');
    }

    /**
     * Sign up for a new account
     */
    function signup() {
      if ($scope.loading) {
        return;
      }
      // Hide the automatic logout message if it exist
      if ($scope.externalMsg) {
        $scope.externalMsg = undefined;
      }

      $scope.isSaveAttempt = true;
      let formElement = $scope.twoFactorAuth ? $('#passcode-form') : $('#signup-form');
      if (!$scope.twoFactorAuth) {
        triggerFormValidation();
      }
      if (!formElement.form('is valid')) {
        return;
      }

      $scope.isPasswordWeak = false;
      $scope.isUsernameUsed = false;
      $scope.loading = true;

      // Confirm passcode
      if ($scope.twoFactorAuth) {
        const username = $scope.user?.email || $scope.userInfo?.user?.userName;
        AuthService.login(username, void 0, $scope.passcode.toUpperCase(), true)
          .then(() => getUserInfo())
          .catch(err => {
            if (err.resultCode === 12) { // Passcode is wrong
              $scope.loading = false;
              ToastsService.error($t('errors.wrongPasscode'), $t('errors.wrongPasscodeDesc'));
            } else {
              handleError(err);
            }
          });
        // Register new user
      } else {
        const phone = $scope.user.phoneCode.toString() + $scope.user.phoneNumber.toString();
        let userInfo = {
          appName: utils.getAppName(),
          firstName: $scope.user.firstName,
          lastName: $scope.user.lastName,
          phoneType: 1,
          phone: phone,
          email: $scope.user.email,
          username: $scope.user.email,
          altUsername: phone,
          password: $scope.user.password
        };
        return registerUser(userInfo);
      }
    }

    /**
     * Register user account.
     * @param {Object} userInfo User data model.
     */
    function registerUser(userInfo) {
      return AuthService.logoutFromThisBrowser()
        .then(() => operationToken.getToken())
        .then((token) => UsersService.registerUser({ user: userInfo }, token))
        .then(() => {
          $scope.twoFactorAuth = true;
          $scope.message = $t('prompt.passcode.sent');
          startCodeCountdown();
        })
        .catch((err) => handleError(err, true))
        .finally(() => {
          if (operationToken.isStopped) {
            operationToken = AuthService.operationToken();
          }
        });
    }

    function startCodeCountdown() {
      $scope.loading = false;
      $scope.countdown = secondsUntilNextPasscodeSend;
      if (codeCountdownInterval) {
        $interval.cancel(codeCountdownInterval);
      }
      codeCountdownInterval = $interval(() => {
        if ($scope.countdown === 0) {
          $interval.cancel(codeCountdownInterval);
          codeCountdownInterval = void 0;
          return;
        }
        $scope.countdown = $scope.countdown - 1;
      }, 1000);
    }

    function cancelCodeCountdown() {
      if ($scope.loading) {
        return;
      }
      if (codeCountdownInterval) {
        $interval.cancel(codeCountdownInterval);
        codeCountdownInterval = void 0;
      }
      $scope.twoFactorAuth = false;
    }

    /**
     * Resend SMS passcode after 120 sec
     */
    function resendCode() {
      if ($scope.loading) {
        return;
      }

      $scope.loading = true;
      $scope.passcode = null;
      $timeout(function() {
        $(FORM_PASSCODE_FIELD_ID)[0].focus();
      }, 0);

      AuthService.login($scope.user.email, $scope.user.password, void 0, true)
        .then(() => ToastsService.success(null, $t('prompt.passcode.sent')))
        .catch(err => {
          // Code sent successfully
          if (err.resultCode === 17) {
            $scope.twoFactorAuth = true;
            $scope.message = err.resultCodeMessage || err.resultCodeDesc;
            startCodeCountdown();
            return;
          }

          $scope.loading = false;
          $scope.user.password = null;
          $scope.user.passwordRepeat = null;
          $scope.twoFactorAuth = false; // Return to username/password step
          handleError(err);

          // Focus to password field
          $timeout(function() {
            $(FORM_PASSWORD_FIELD_ID)[0].focus();
          }, 0);
        });
    }

    // #endregion

    // #region Company Methods

    /**
     * Initiate company step for proper form validatipon
     */
    function initCompanyStep() {
      // Hide the automatic logout message if it exist
      if ($scope.externalMsg) {
        $scope.externalMsg = undefined;
      }

      $scope.uiStep = 'company';

      return $q.all([
        initCountries(),
        initForms()
      ])
        .then(() => {
          $scope.loading = false;
          $scope.$watch('selectedCountry', () => changeCountry());
          $scope.$watch('selectedState', () => changeState());
        })
        .catch((err) => handleError(err));
    }

    function initCountries() {
      return LocationsService.getCountries()
        .then((data) => {
          $scope.countries = data.countries;
          return data;
        });
    }

    function initForms() {
      $.fn.form.settings.rules.zipRule = function(value) {
        if (!value) {
          return true;
        }
        if ($scope.selectedCountry && $scope.selectedCountry.zipFormat) {
          return new RegExp($scope.selectedCountry.zipFormat).test(value);
        }
        return true;
      };

      $('#company-form').form({
        inline: true,
        fields: {
          name: {
            rules: [
              {
                type: 'empty',
                prompt: $t('prompt.empty')
              }
            ]
          },
          website: {
            rules: [
              {
                type: 'url',
                prompt: $t('orgs.register.prompt.website')
              }
            ]
          },
          zip: {
            rules: [
              {
                type: 'zipRule',
                prompt: $t('prompt.zip.reg')
              }
            ]
          }
        }
      });
    }

    function changeCountry() {
      $scope.selectedStateId = undefined;
      $scope.selectedState = undefined;
      if (!$scope.selectedCountry) {
        return;
      }

      if ($scope.selectedCountry.states && $scope.selectedCountry.states.length > 0) {
        $scope.selectedState = $scope.selectedCountry.states[0];
        $scope.selectedStateId = $scope.selectedCountry.states[0].id;
      }
    }

    function changeState() {
      $scope.selectedTimezoneId = undefined;
      $scope.selectedTimezone = undefined;
      if (!$scope.selectedCountry) {
        return;
      }

      if ($scope.selectedCountry.timezones && $scope.selectedCountry.timezones.length > 0) {
        if ($scope.selectedState && $scope.selectedState.timezoneId) {
          $scope.selectedTimezone = $scope.selectedCountry.timezones.find(el => el.id === $scope.selectedState.timezoneId);
          $scope.selectedTimezoneId = $scope.selectedTimezone ? $scope.selectedTimezone.id : undefined;
        }
        if (!$scope.selectedTimezone) {
          $scope.selectedTimezone = $scope.selectedCountry.timezones[0];
          $scope.selectedTimezoneId = $scope.selectedCountry.timezones[0].id;
        }
      }
    }

    /**
     * Submit company form
     */
    function confirm() {
      if ($scope.loading) {
        return;
      }

      // Hide the automatic logout message if it exist
      if ($scope.externalMsg) {
        $scope.externalMsg = undefined;
      }

      let formElement = $('#company-form');
      if (!formElement.form('is valid')) {
        return;
      }

      return createOrganization()
        .finally(() => getUserInfo());
    }

    function logoAddHandler($file, $event, $flow) {
      flowFile = null;
      let flag = !!{ png: 1, gif: 1, jpg: 1, jpeg: 1 }[$file.getExtension()];
      if (!flag) {
        ToastsService.warning(null, $t('signup.errors.logo.type'));
        return false;
      }
      let size = $file.size;
      if (size > 10 * 1024 * 1024) {
        ToastsService.warning(null, $t('signup.errors.logo.size'));
        return false;
      }
      // Upload file only after organization created
      flowFile = $file.file;
      const fileType = $file.getType();
      $scope.fileType = fileType ? 'image/' + $file.getType() : 'image/png';
      return true;
    }

    /**
     * Create new organization
     */
    function createOrganization() {
      $scope.loading = true;

      const country = $scope.selectedCountry && { id: $scope.selectedCountryId };
      const state = $scope.selectedState && { id: $scope.selectedStateId };
      const timezone = $scope.selectedTimezone && { id: $scope.selectedTimezoneId };

      // Organization details
      const organization = {
        name: $scope.company.name,
        domainName: $scope.company.name.replace(/[^a-zA-Z0-9]/g, '').toUpperCase(),
        features: 'g,n,p,s', // Groups, Notifications, Place Ranking, Store URL
        contactName1: $scope.userInfo.user.firstName + ' ' + $scope.userInfo.user.lastName,
        contactEmail1: $scope.userInfo.user.email.email,
        contactPhone1: utils.formatPhoneNumber($scope.userInfo.user.phone, 1, true),
        addrStreet1: $scope.company.address || '',
        addrCity: $scope.company.city || '',
        zip: $scope.company.zip || ''
      };

      // Location details
      const location = {
        name: organization.contactName1 + '\'s ' + 'Home',
        type: 10, // Residence
        addrStreet1: $scope.company.address || '',
        addrCity: $scope.company.city || '',
        zip: $scope.company.zip || ''
      };

      if (country) {
        organization.country = country;
        location.country = country;
      }
      if (state) {
        organization.state = state;
        location.state = state;
      }
      if (timezone) {
        location.timezone = timezone;
      }

      let organizationId;
      return OrganizationService.createOrganization({
        organization: organization
      })
        .then((data) => {
          // Get ID of created organization
          organizationId = data.organizationId;
        }, (err) => handleError(err))

        .then(() => {
          return OrganizationService.updateObjectsAndProperties(organizationId, [
            { name: ORG_BUSINESS_PROPERTY, value: $scope.company.website },
            { name: ORG_COMPANY_PROPERTY, value: $scope.company.name },
            { name: ORG_WEBSITE_PROPERTY, value: ORG_WEBSITE_URI },
            { name: 'signupForm', value: true }
          ]);
        })

        .then(() => {
          if (!flowFile) {
            return;
          }

          // Upload organisation logo
          return OrganizationService.uploadLargeObject(
            organizationId,
            flowFile,
            ORG_LOGO_PROPERTY,
            false,
            $scope.fileType);
        })

        .then(() => createLocation(location, organizationId));
    }

    /**
     * Create example location
     * @param {Object} locationLocation data model
     * @param {number} organizationId
     */
    function createLocation(location, organizationId) {
      const locationData = { location: location };
      const userData = { userId: $scope.userInfo.user.id };

      return LocationsService.createLocation(organizationId, locationData, userData)
        .then((data) => {
          if (data && data.locationId) {

            // Search for available subscriptions
            return SubscriptionsService.getAvailableServicePlans(data.locationId, void 0, organizationId)
              .then((plans) => {
                const availablePlan = plans?.servicePlans?.find(s => s.available);
                if (availablePlan) {

                  // Assign first available subscription
                  return SubscriptionsService.grantSubscriptionToLocations(availablePlan.id, [
                    {
                      locationId: data.locationId
                    }
                  ], organizationId);
                }
              });
          }
        });
    }

    // #endregion

  }
}

export default angular
  .module('signup.controller', [])
  .controller('SignupController', SignupController)
  .name;
